// @flow

import moment from 'moment';

import ApiObject from '../ApiObject';
import DateUtils from '../../utils/DateUtils';

export default class DeliveryFixTimeSettings extends ApiObject {

  time: MsTimestamp;

  getTimeAsMinutes(): number {
    return DateUtils.millisecondsToMinutes(this.time);
  }

  setTimeFromMinutes(minutes: number) {
    this.time = DateUtils.minutesToMilliseconds(minutes);
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/DeliveryFixTimeSettings.js